import api from './../../api/api'

export default {

  paymentTypes: async () => {
    return api.get('api/contributions/payment-types')
  },

  debitTypes: async () => {
    return api.get('api/contributions/debit-types')
  },

  outstanding: async (schemeId,year, month, page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/contributions/outstanding/${schemeId}/${year}/${month}?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  outstandingUpdate: async contribution => {
    return api.post('api/contributions/outstanding', contribution)
  },

  processed: async (schemeId,year, month, page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/contributions/processed/${schemeId}/${year}/${month}?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  reverseProcessed: async contribution => {
    return api.post('api/contributions/reverse-processed', contribution)
  },


  adHocGetData: async (schemeId,page, take, sortBy, sortOrder, search, filters)=> {
    return api.get(`api/contributions/ad-hoc/${schemeId}?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  adHoc: async (contributor) => {
    return api.post('api/contributions/ad-hoc',contributor)
  },



  debits: async (schemeId,page, take, sortBy, sortOrder, search, filters)=> {
    return api.get(`api/contributions/debits/${schemeId}?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  debitCreate: async (debit) => {
    return api.post('api/contributions/debits',debit)
  },

  reverseDebit: async (debit) => {
    return api.post('api/contributions/reverse-debit',debit)
  }
}
